var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAnalyticsinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  fill: "none",
  viewBox: "0 0 30 30"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.125 30A13.14 13.14 0 0 0 26.25 16.875a.624.624 0 0 0-.625-.625h-11.25a.624.624 0 0 1-.625-.625V4.375a.625.625 0 0 0-.625-.625 13.125 13.125 0 0 0 0 26.25"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.875 0a.625.625 0 0 0-.625.625V12.5a1.25 1.25 0 0 0 1.25 1.25h11.875a.624.624 0 0 0 .625-.625A13.14 13.14 0 0 0 16.875 0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h30v30H0z"
})))));
export default SvgAnalyticsinline;